import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n\tmin-height: ", ";\n"]);

  _templateObject13 = function () {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n\tmin-height: ", ";\n"]);

  _templateObject12 = function () {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n\tfont-size: ", ";\n\tfont-weight: bold;\n\theight: 0;\n\toverflow: hidden;\n\tvisibility: hidden;\n"]);

  _templateObject11 = function () {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground: transparent;\n"]);

  _templateObject10 = function () {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground: ", ";\n\theight: calc(100% - 4px - 4px);\n\tposition: absolute;\n\tright: 0;\n\ttop: 4px;\n\ttransition: background ", " linear;\n\twidth: 1px;\n"]);

  _templateObject9 = function () {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n\tcolor: ", ";\n\tfont-weight: bold;\n"]);

  _templateObject8 = function () {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\tfont-size: ", ";\n\tleft: 50%;\n\tline-height: 1;\n\tposition: absolute;\n\ttop: 50%;\n\ttransform: translate(-50%, -50%);\n"]);

  _templateObject7 = function () {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\talign-items: center;\n\tappearance: none;\n\tbackground: transparent;\n\tborder: none;\n\tborder-radius: ", ";\n\tcolor: ", ";\n\tcursor: pointer;\n\tdisplay: flex;\n\theight: 100%;\n\tjustify-content: center;\n\tline-height: 100%;\n\toutline: none;\n\tpadding: 0 12px;\n\tposition: relative;\n\ttext-align: center;\n\ttransition: background ", " linear,\n\t\tcolor ", " linear,\n\t\tfont-weight 60ms linear;\n\tuser-select: none;\n\twidth: 100%;\n\tz-index: 2;\n\n\t&::-moz-focus-inner {\n\t\tborder: 0;\n\t}\n\n\t&:active {\n\t\tbackground: ", ";\n\t}\n"]);

  _templateObject6 = function () {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tflex: 1;\n"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: inline-flex;\n\tmax-width: 100%;\n\tmin-width: 0;\n\tposition: relative;\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground: ", ";\n\tborder: 1px solid ", ";\n\tborder-radius: ", ";\n\tbox-shadow: ", ";\n\theight: calc(", " - 4px);\n\tleft: 0;\n\tposition: absolute;\n\ttransition: all ", " ease;\n\tz-index: 1;\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\twidth: 100%;\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground: ", ";\n\tborder: 1px solid;\n\tborder-color: ", ";\n\tborder-radius: calc(", " + 1px);\n\tdisplay: inline-flex;\n\tmin-height: ", ";\n\tmin-width: 0;\n\tpadding: 1px;\n\tposition: relative;\n\ttransition: all ", " linear;\n\n\t&:hover {\n\t\tborder-color: ", ";\n\t}\n\n\t&:focus {\n\t\tborder-color: ", ";\n\t\tbox-shadow: ", ";\n\t\toutline: none;\n\t\tz-index: 1;\n\t}\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, styled, ui } from '@wp-g2/styles';
export var SegmentedControl = css(_templateObject(), ui.get('segmentedControlBackgroundColor'), ui.get('segmentedControlBorderColor'), ui.get('controlBorderRadius'), ui.get('controlHeight'), ui.get('transitionDurationFastest'), ui.get('controlBorderColorHover'), ui.color.admin, ui.get('controlBoxShadowFocus'));
export var block = css(_templateObject2());
export var BackdropView = styled.div(_templateObject3(), ui.get('segmentedControlBackdropBackgroundColor'), ui.get('segmentedControlBackdropBorderColor'), ui.get('controlBorderRadius'), ui.get('segmentedControlBackdropBoxShadow'), ui.get('controlHeight'), ui.get('transitionDurationFast'));
export var LabelView = styled.div(_templateObject4());
export var labelBlock = css(_templateObject5());
export var ButtonView = styled.button(_templateObject6(), ui.get('controlBorderRadius'), ui.color.text, ui.get('transitionDurationFast'), ui.get('transitionDurationFast'), ui.get('segmentedControlButtonColorActive'));
export var ButtonContentView = styled.div(_templateObject7(), ui.get('segmentedControlFontSize'));
export var buttonActive = css(_templateObject8(), ui.get('controlTextActiveColor'));
export var SeparatorView = styled.div(_templateObject9(), ui.get('colorDivider'), ui.get('transitionDuration'));
export var separatorActive = css(_templateObject10());
export var LabelPlaceholderView = styled.div(_templateObject11(), ui.get('segmentedControlFontSize'));
export var large = css(_templateObject12(), ui.get('controlHeightLarge'));
export var small = css(_templateObject13(), ui.get('controlHeightSmall'));